<template>
    <div>
     <div class="layout d-flex">
            <!-- Barra Lateral -->
            <aside id="layoutSidebar" class="layoutSidebar collapse d-lg-block col-3">
            <!-- <aside id="layoutSidebar" class="layoutSidebar d-none d-lg-block"> -->
                <div class="d-flex flex-column justify-content-between pt-3">
                    <nav class="sidebar-nav p-2">
                         <div class="nav-heading pb-3">
                            <router-link to="/">I n i c i o</router-link>
                        </div>
                        <div class="nav-heading">Solicitud de Plazas</div>
                        <ul class="navbar-nav">
                            <li><router-link class="nav-link" to="/verano">VERANO</router-link></li>
                            <li><router-link class="nav-link" to="/campamentos">CAMPAMENTOS</router-link></li>
                            <!-- <li><router-link class="nav-link disabled" to="/semanasanta">Semana Santa</router-link></li> -->
                            <li><router-link class="nav-link disabled" to="/idiomas">IDIOMAS EXTRANJERO</router-link></li>
                        </ul>
                        <div class="nav-heading">Reservas</div>
                        <ul class="navbar-nav">
                            <li><router-link class="nav-link" to="/reservas">RESERVAS</router-link></li>
                            <li><router-link class="nav-link" to="/vacantes">VACANTES Verano</router-link></li>
                            <!-- <li><router-link class="nav-link" to="/vacantesNo">Vacantes Verano No Adjudicados</router-link></li> -->
                            <li><router-link class="nav-link" to="/vacantes-campamentos">VACANTES Campamentos</router-link></li>
                        </ul>
                        <div class="nav-heading">Información</div>
                        <ul class="navbar-nav">
                            <li><router-link class="nav-link" to="/catalogo">CATÁLOGO</router-link></li>
                            <li><router-link class="nav-link" to="/normativas">NORMATIVAS</router-link></li>
                            <!-- <li><router-link class="nav-link disabled" to="/semanasanta">Semana Santa</router-link></li> -->
                            <li><router-link class="nav-link" to="/">INFORMACIÓN de Interes</router-link></li>
                            <!-- <li><router-link class="nav-link" to="/condiciones-generales">Condiciones Generales</router-link></li> -->
                            <hr>
                            <li><a href="https://fondos-sociales.com/pdf/privacidad.pdf" target="_blank">Politica de Privacidad</a></li>
                            <li><a href="https://fondos-sociales.com/pdf/cookies.pdf" target="_blank">Cookies</a></li>
                        </ul>
                    </nav>

                    <!-- <div class="sidebar-footer">
                        <div class="sidebar-footer-content">
                            <div class="sidebar-footer-subtitle">Usuario:</div>
                            <div class="sidebar-footer-title">Juan Francisco Visiedo</div>
                        </div>
                    </div> -->
                </div>
            </aside>
            <div class="cuerpo col-9">
                <router-view/>
            </div>
    </div>



    </div>
</template>

<script>

export default {
    name: 'AppMenu',
    components: {

    },
    data: () => ({
        //titulo: 'PAGINA WEB',
    }),
    computed: {
        logueado() {
            return this.$store.state.auth.logueado;
        },
        usuario() {
            return this.$store.state.auth.user.usu;
        },
        tit() {
            //return "hola";
            return this.$store.state.G.pagina;
        }

    },
    methods: {
        acceso() {
            if (this.logueado) this.desconectar();
        },

        login() {
            //this.$root.$emit('modal','modal_login');
            this.$bvModal.show("modal_login");
        },
        registro() {
            this.$bvModal.show("modal_registro");
        },

        desconectar() {
            //alert('La sesion se ha desconectado ...');
            this.$store.commit('modal',{tit:"Desconectar",msg:"Se ha desconectado de la Sesion"});
            this.$store.commit('login_off');
            this.$router.push('/');
        },
        openAlerta() {

            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete everything.', {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'ACEPTAR',
                cancelTitle: 'CANCELAR',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                //this.boxTwo = value
                console.log(value);
            })
            .catch(error => {
                // An error occurred
                console.log(error)
            })
        }
    },

}
</script>